import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ProfileContext, ProfileManager } from '../profile';

export interface AuthProps {
  component: any;
  path: string;
}

const isAdmin = (context: ProfileManager): boolean => {
  return context.profile !== null && context.profile.type === 'admin';
};

const redirectRoute = (context: ProfileManager): string => {
  return context.profile !== null ? '/dashboard' : '/login';
};

export default function AdminRoute({
  component: Component,
  ...props
}: AuthProps) {
  const context = React.useContext(ProfileContext);

  return (
    <Route
      {...props}
      render={props =>
        isAdmin(context) ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: redirectRoute(context),
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}
